import { ProcessingStatus } from '@or-sdk/billing';

export const PROCESSING_STATUS_MAP = {
  [ProcessingStatus.QUEUED]: 'Queued',
  [ProcessingStatus.PENDING]: 'Pending',
  [ProcessingStatus.IN_PROGRESS]: 'Processing',
  [ProcessingStatus.SUCCESS]: 'Success',
  [ProcessingStatus.ERROR]: 'Error',
  [ProcessingStatus.CANCELED]: 'Canceled',
};
